
import PropTypes from 'prop-types'
import { Paper, TableContainer, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'

const FbtTable = ({ data }) => {

  return (
    <div
      style={{
        width: '100%',
        height: 600,
        '@media (min-width: 600px)': {
          height: '100%',
        },
      }}>
      <Paper>
        <TableContainer>
          <Table stickyHeader aria-label="service history table">

            <TableHead>
              <TableRow>
                {[
                  { label: 'Month', sx: { maxWidth: 100 } },
                  { label: 'Year', sx: { maxWidth: 100 } },
                  { label: 'Driver Name', sx: { maxWidth: 100 } },
                  { label: 'Cost Centre', sx: { maxWidth: 100 } },
                  { label: 'Total Days Vehicle Available', sx: { maxWidth: 100 } },
                  { label: 'Exempt Days', sx: { maxWidth: 100 } },
                  { label: 'Days Available For Pvt Use', sx: { maxWidth: 100 } },
                  { label: 'FBT Exempt Notes', sx: { maxWidth: 150 } },
                ].map((item, index) => (
                  <TableCell
                    key={`table-heading-${index}`}
                    align="center"
                    sx={{
                      color: '#546E7A',
                      fontSize: '10px',
                      letterSpacing: '-0.04px',
                      lineHeight: '16px',
                      textAlign: 'center',
                    }}>
                    <strong>{item?.label}</strong>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {data && data.length > 0 ? data.map((item, rowIndex) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={`table-row-${rowIndex}`}>
                  <TableCell key={`table-serviceDate-column-${rowIndex}`} align="center" sx={{ verticalAlign: 'top' }}>
                    {item?.month || '-'}
                  </TableCell>
                  <TableCell key={`table-serviceDate-column-${rowIndex}`} align="center" sx={{ verticalAlign: 'top' }}>
                    {item?.year || '-'}
                  </TableCell>
                  <TableCell key={`table-serviceOdo-column-${rowIndex}`} align="center" sx={{ verticalAlign: 'top' }}>
                    {item?.driverName || '-'}
                  </TableCell>
                  <TableCell key={`table-serviceType-column-${rowIndex}`} align="center" sx={{ verticalAlign: 'top' }}>
                    {item?.costCentre || '-'}
                  </TableCell>
                  <TableCell
                    key={`table-dealership-column-${rowIndex}`}
                    align="center"
                    sx={{
                      maxWidth: 100,
                      verticalAlign: 'top',
                    }}>
                    {item?.totalDaysVehicleAvailable || '-'}
                  </TableCell>
                  <TableCell
                    key={`table-dealership-column-${rowIndex}`}
                    align="center"
                    sx={{
                      maxWidth: 100,
                      verticalAlign: 'top',
                    }}>
                    {item?.exemptDays || '-'}
                  </TableCell>
                  <TableCell
                    key={`table-dealership-column-${rowIndex}`}
                    align="center"
                    sx={{
                      maxWidth: 100,
                      verticalAlign: 'top',
                    }}>
                    {item?.daysAvailableForPvtUse || '-'}
                  </TableCell>
                  <TableCell key={`table-dealership-column-${rowIndex}`} align="center" sx={{ verticalAlign: 'top' }}>
                    {item?.exemptNotes || '-'}
                  </TableCell>
                </TableRow>
              )) : (
                <TableRow>
                  <TableCell align="center" colSpan={4}>
                    No vehicle history available.
                  </TableCell>
                </TableRow>
              )}

            </TableBody>

          </Table>
        </TableContainer>
      </Paper>
    </div>
  )
}

FbtTable.propTypes = {
  data: PropTypes.array,
}

export default FbtTable
